export default {
	'add-new-company-history': '',
	'the-company-history': '',
	'company-history': '',
}